import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-request-clarification',
  templateUrl: './request-clarification.component.html',
  styleUrls: ['./request-clarification.component.scss'],
  standalone: false,
})
export class RequestClarificationComponent implements OnDestroy {
  constructor() {}

  ngOnDestroy() {
    sessionStorage.removeItem('savedFilters');
  }
}
